import Button from "react-bootstrap/Button";

function LongButton(props) {
  //const bgColor = process.env.REACT_APP_BG_COLOR;
  return (
    <>
      <div className="d-grid">
        {props.isDisabled ? (
          <Button
            className={props.class}
            style={{
              backgroundColor: props.bgColor,
              color: props.fontColor,
              border: "none",
            }}
            onClick={props.onClick}
            active={false}
          >
            請稍候...
          </Button>
        ) : (
          <Button
            className={props.class}
            style={{
              backgroundColor: props.bgColor,
              color: props.fontColor,
              border: "none",
            }}
            onClick={props.onClick}
          >
            {props.text}
          </Button>
        )}
      </div>
    </>
  );
}

export default LongButton;
